<template>
    <div class="col-sm-12 col-xl-12 box-col-12 col-12">
      <div class="card p-4">
        <div class="card-header">
            <h3>Need help with something?</h3>
            <p>Get in touch with our support team.</p>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-xxl-4 col-12">
                    <i class="fa fa-tablet"></i>
                    <span>Call Monday to Friday 10am to 5pm</span>
                    <div class="help-text">0280&nbsp;060&nbsp;696</div>
                </div>
                <div class="col-xxl-4 col-12">
                    <i class="fa fa-envelope-o"></i>
                    <span>Drop us an email</span>
                    <div class="help-text">support@taxi1.com.au</div>
                </div>
                <div class="col-xxl-4 col-12">
                    <i class="fa fa-comments-o"></i>
                    <span>Send us an SMS</span>
                    <div class="help-text">0466&nbsp;048&nbsp;009</div>
                </div>
            </div>
          </div>
        </div>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>

  p{
    font-size: 24px;
  }

  i{
    font-size: 30px;
    margin-bottom: 20px;
    display: flex;
  }

  .help-text{
    margin-top: 10px;
    color: #06fe7f;
    font-size: 26px;
  }
  </style>
  